//React
import { FunctionComponent, useEffect } from "react";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectIsQmiFinder } from "../../redux/selectors/select-is-qmi-finder";
import { selectIsAppLoaded } from "../../../system/redux/selectors/select-app-loaded";

/** Syncs Home of the Week boolean with it's url param. */
export const UrlManagerHotw: FunctionComponent = (props) => {
    
    //State Values
    const appLoaded = useAppSelector(selectIsAppLoaded);
    const isQmiFinder = useAppSelector(selectIsQmiFinder);

    //Use Effects
    useEffect(() => {
        //If the app has not been loaded yet do not adjust the url.
        if (!appLoaded) {
			return;
		}

        var currentUrl = new URL(window.location.href.toLowerCase());

        if (!isQmiFinder) {
            //If we are not in the QMI finder then we want to remove the homes param if it exists, 
            // otherwise we do not want to do anything.
            if(!currentUrl.searchParams.has("homes"))
            {
                return;
            }
            else
            {
                currentUrl.searchParams.delete("homes");
            }
		}
        else
        {
            //Do not do anything if the URL already has the param.
            if(currentUrl.searchParams.has("homes")) 
            {
                return;
            }

            currentUrl.searchParams.set("homes", "hotw");
        }

		

		window.history.replaceState({}, window.document.title, currentUrl);
    }, [isQmiFinder, appLoaded]);

    return null;
};